module.exports = __webpack_public_path__ + "img/1504667148.799061b7.jpg";